import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiButton, MuiTextField, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ExpansionPanelSummary, ExpansionPanel, ExpansionPanelDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";

class FixedTeachersAndTAsComponent extends Component {

	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				<MuiGrid>
					<MuiGrid container style={{ marginBottom: "2%" }} >
						<MuiGrid item xs={12}>
							{this.props.elective.subjects.map((subject, index) =>

								<ExpansionPanel >
									<ExpansionPanelSummary
										onClick={() => this.props.showTeachersAndTAs(subject)}
										expandIcon={<ExpandMoreIcon />}
										aria-controls="panel1a-content"
										id="panel1a-header"

									>
										<MuiGrid container>
											<MuiToolTip
												placement="top-start"
												title={StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAsElective.headingForTeacher,
													{
														Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
														Subject: subject.name,
														Grades: DialogComponentUtil.getToolTipString(this.props),
													})
												} >
												<MuiTypography style={theme.typography.h6} gutterBottom>
													{StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAsElective.headingForTeacher,
														{
															Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
															Subject: subject.name,
															Grades: DialogComponentUtil.getGradeForTemplate(this.props),
														})
													}
												</MuiTypography>
											</MuiToolTip>
										</MuiGrid>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{/* {this.props.teachersAndTAsAccor && */}

										<MuiGrid>
											<MuiGrid container xs={12} alignItems="left" >
												<MuiGrid item xs={6} container alignItems="center" >
													<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
														<MuiTypography style={theme.tableHeaderTextStyle}>
															{i18n.fixedTeachersAndTAs.fixedTeacher}
														</MuiTypography>
													</MuiGrid>

													<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
														<Autocomplete
															id="combo-box-demo"
															multiple
															value={this.props.fixedTeachersAndTAsForElective.teachersAndTAs[index].teachers.fixed}
															options={this.props.numberOfTeachers}
															getOptionLabel={option => option.firstName !== undefined ? option.firstName + "-" + option.teacherId : option.teacherId}
															style={{ width: 400 }}
															onChange={(event, value) => { this.props.handleChangeForTeachersElectives('fixed', event, value, subject, index) }}
															renderInput={params => (
																<MuiTextField
																	{...params}
																	fullWidth
																	InputProps={{ ...params.InputProps, disableUnderline: true }}
																/>)}
														/>
													</MuiGrid>
												</MuiGrid>
												<MuiGrid item xs={6} container >
													<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
														<MuiTypography style={theme.tableHeaderTextStyle}>
															{i18n.fixedTeachersAndTAs.preferredTeacher}
														</MuiTypography>
													</MuiGrid>
													<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
														<Autocomplete
															id="combo-box-demo"
															multiple
															value={this.props.fixedTeachersAndTAsForElective.teachersAndTAs[index].teachers.preferred}
															options={this.props.numberOfTeachers}
															getOptionLabel={option => option.firstName !== undefined ? option.firstName + "-" + option.teacherId : option.teacherId}
															style={{ width: 400 }}
															onChange={(event, value) => { this.props.handleChangeForTeachersElectives('preferred', event, value, subject, index) }}
															renderInput={params => (
																<MuiTextField
																	{...params}
																	fullWidth
																	InputProps={{ ...params.InputProps, disableUnderline: true }}
																/>)} />
													</MuiGrid>
												</MuiGrid>
											</MuiGrid>

											<MuiGrid container style={{ marginTop: "5%" }}>
												<MuiGrid item xs={12} style={{ paddingBottom: "2%" }}>
													<MuiToolTip
														placement="top-start"
														title={StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAsElective.headingForTAs,
															{
																Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
																Subject: subject.name,
																Grades: DialogComponentUtil.getToolTipString(this.props),
															})
														} >
														<MuiTypography style={theme.typography.h6} gutterBottom>
															{StringReplacer.getFormatedMessage(i18n.fixedTeachersAndTAsElective.headingForTAs,
																{
																	Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
																	Subject: subject.name,
																	Grades: DialogComponentUtil.getGradeForTemplate(this.props),
																})
															}
														</MuiTypography>
													</MuiToolTip>
												</MuiGrid>
												<MuiGrid container xs={12} alignItems="left" >
													<MuiGrid item xs={6} container alignItems="center" >
														<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
															<MuiTypography style={theme.tableHeaderTextStyle}>
																{i18n.fixedTeachersAndTAs.fixedTA}
															</MuiTypography>
														</MuiGrid>
														<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
															<Autocomplete
																id="combo-box-demo"
																multiple
																value={this.props.fixedTeachersAndTAsForElective.teachersAndTAs[index].TAs.fixed}
																options={this.props.numberOfTAs}
																getOptionLabel={option => option.firstName !== undefined ? option.firstName + "-" + option.teacherId : option.teacherId}
																onChange={(event, value) => { this.props.handleChangeForTAsElectives('fixed', event, value, subject, index) }}
																style={{ width: 400 }}
																renderInput={params => (
																	<MuiTextField
																		{...params}
																		fullWidth
																		InputProps={{ ...params.InputProps, disableUnderline: true }}
																	/>)} />
														</MuiGrid>
													</MuiGrid>
													<MuiGrid item xs={6} container >
														<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle} xs={11}>
															<MuiTypography style={theme.tableHeaderTextStyle}>
																{i18n.fixedTeachersAndTAs.preferredTA}
															</MuiTypography>
														</MuiGrid>
														<MuiGrid container style={theme.gridTableSelectStyle} xs={11}>
															<Autocomplete
																id="combo-box-demo"
																multiple
																value={this.props.fixedTeachersAndTAsForElective.teachersAndTAs[index].TAs.preferred}
																options={this.props.numberOfTAs}
																getOptionLabel={option => option.firstName !== undefined ? option.firstName + "-" + option.teacherId : option.teacherId}
																onChange={(event, value) => { this.props.handleChangeForTAsElectives('preferred', event, value, subject, index) }}
																style={{ width: 400 }}
																renderInput={params => (
																	<MuiTextField
																		{...params}
																		fullWidth
																		InputProps={{ ...params.InputProps, disableUnderline: true }}
																	/>)} />
														</MuiGrid>
													</MuiGrid>
												</MuiGrid>
											</MuiGrid>
										</MuiGrid>
									</ExpansionPanelDetails>
								</ExpansionPanel>)}
						</MuiGrid>
					</MuiGrid>
				</MuiGrid>
				<MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>
					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>
					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => this.props.onClickOfSave()}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>
			</React.Fragment>
		)
	}
}
export default FixedTeachersAndTAsComponent
